// src/utils/customerCcMap.ts

export const customerCcMap: Record<string, string[]> = {
  "Orange MALI": [
    "yacine.diallo@ses.com",
    "Walid.Wehbe2@ses.com",
    "Georges.Abikhalil@ses.com",
    "a.maiga@bcomsat.com",
  ],
  "Orange DRC": ["yorgo.amine@ses.com", "Walid.Wehbe2@ses.com", "pllessenge@bcomsat.com"],
  "Airtel DRC": ["jamil.sbeit@ses.com", "Walid.Wehbe2@ses.com"],
  Conecel: ["Rogerio.Tuyama@ses.com", "Walid.Wehbe2@ses.com", "Maria.Valle@ses.com"],
  Asecna: ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com", "pllessenge@bcomsat.com"],
  "MTN SSD": ["Neels.Vanheerden@ses.com", "Walid.Wehbe2@ses.com"],
  "Zamani Niger": ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com"],
  "Claro Nicaragua": [
    "Ricardo.Moreira@ses.com",
    "Walid.Wehbe2@ses.com",
    "Maria.Valle@ses.com",
    "yamil.gutierrez@ses.com",
  ],
  "MTC Namibia": ["Rudolph.Cloete@ses.com", "Walid.Wehbe2@ses.com"],
  "MTN Congo": ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com"],
  "Solomon Telekom": ["Neels.Vanheerden@ses.com", "Walid.Wehbe2@ses.com"],
  "Telecom Namibia": ["Rudolph.Cloete@ses.com", "Walid.Wehbe2@ses.com"],
  "MTN Nigeria": ["Neels.Vanheerden@ses.com", "Walid.Wehbe2@ses.com"],
  "Vodacom South Africa": [
    "Rudolph.Cloete@ses.com",
    "Walid.Wehbe2@ses.com",
    "Neels.Vanheerden@ses.com",
  ],
  "Vodacom Mozambique": [
    "Rudolph.Cloete@ses.com",
    "Walid.Wehbe2@ses.com",
    "Neels.Vanheerden@ses.com",
  ],
  "Vodacom DRC": ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com", "Ricardo.Moreira@ses.com"],
  "CBH-DRC": [
    "Elie.Moukhaiber@ses.com",
    "Walid.Wehbe2@ses.com",
    "Ricardo.Moreira@ses.com",
    "pllessenge@bcomsat.com",
  ],
  "TIM Brazil": ["Rogerio.Tuyama@ses.com", "Walid.Wehbe2@ses.com", "Ricardo.Moreira@ses.com"],
  "Orange Cote d'Ivoire": ["yacine.diallo@ses.com", "Walid.Wehbe2@ses.com"],
  "Airtel Chad": ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com"],
  Telebras: ["Rogerio.Tuyama@ses.com", "Walid.Wehbe2@ses.com", "Ricardo.Moreira@ses.com"],
  Petrobras: ["Rogerio.Tuyama@ses.com", "Walid.Wehbe2@ses.com", "Ricardo.Moreira@ses.com"],
  "Orange Burkina Fasso": ["Elie.Moukhaiber@ses.com", "Walid.Wehbe2@ses.com"],
};

const cbhCcMap: Record<string, string[]> = {
  "Orange DRC": [
    "Elie.Moukhaiber@ses.com",
    "Walid.Wehbe2@ses.com",
    "yorgo.amine@ses.com",
    "Ricardo.Moreira@ses.com",
  ],
  "Airtel DRC": [
    "Elie.Moukhaiber@ses.com",
    "Walid.Wehbe2@ses.com",
    "yorgo.amine@ses.com",
    "Ricardo.Moreira@ses.com",
  ],
};

/**
 * Returns the customer/network-specific recipients that replace the
 * generic "COE support" group for a given change.
 */
export const getCustomerCc = (
    affectedCustomer?: string | string[],
    affectedNetwork?: string | string[]
): string[] => {
  const customers = Array.isArray(affectedCustomer)
      ? affectedCustomer.map(c => c.trim()).filter(Boolean)
      : affectedCustomer
          ? [affectedCustomer.trim()]
          : [];

  const networks = Array.isArray(affectedNetwork)
      ? affectedNetwork.map(n => n.trim()).filter(Boolean)
      : affectedNetwork
          ? [affectedNetwork.trim()]
          : [];

  if (customers.length === 0) {
    return [];
  }

  const emails = new Set<string>();

  customers.forEach(customer => {
    const isCBH = networks.some(network =>
        network.toUpperCase().startsWith("CBH")
    );

    if (isCBH && customer in cbhCcMap) {
      cbhCcMap[customer].forEach(email => emails.add(email));
    } else if (customer in customerCcMap) {
      customerCcMap[customer].forEach(email => emails.add(email));
    }
  });

  return Array.from(emails);
};
